type PageHeroProps = {
  title: string;
  desc: string;
  tag: string;
  bg: string;
};

export default function PageHero({ title, desc, tag, bg }: PageHeroProps) {
  return (
    <section className="relative flex min-h-[340px] w-full items-end overflow-hidden md:min-h-[400px]">
      <div className="absolute inset-0">
        <img src={bg} alt={`${title}背景图`} className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/45 to-foreground-950/80"></div>
      </div>
      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-10 pt-20 md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-3.5 py-1.5 text-xs font-medium text-background-50">
          <i className="ri-graduation-cap-line"></i>
          {tag}
        </span>
        <h1 className="font-heading mt-4 text-2xl text-background-50 md:text-4xl">{title}</h1>
        <p className="mt-3 max-w-2xl text-sm leading-7 text-background-100 md:text-base">{desc}</p>
      </div>
    </section>
  );
}